export default "__VITE_PUBLIC_ASSET__9a1d6657__"